export default "__VITE_ASSET__d2rgN_eu__"